import React, { Component, } from "react";
import GoogleAnalytics from "react-ga";

// GoogleAnalytics.initialize("UA-210078795-1");
// GoogleAnalytics.ga('create', 'UA-210078795-1', 'auto');
export const gaEvent =(eventCategory:string,eventAction:string,eventLabel:string)=>{

  GoogleAnalytics.ga('send', {
    hitType: 'event',
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel
  });
}
const withTracker = (WrappedComponent:any, options = {}) => {
  const trackPage = (page:any )=> {
    GoogleAnalytics.set({
      page,
      ...options,
    });
    GoogleAnalytics.pageview(page);
  };

  // eslint-disable-next-line
  const HOC = class extends Component<any> {
    componentDidMount() {
      // eslint-disable-next-line
      const page = this.props.location.pathname + this.props.location.search;
      trackPage(page);
    }

    componentDidUpdate(prevProps: any) {
      const currentPage =
        prevProps.location.pathname + prevProps.location.search;
      const nextPage =
        this.props.location.pathname + this.props.location.search;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;

